import { ArrowLeft } from 'lucide-react'

export default function OperatingAgreementPage({ onBack }: { onBack: () => void }) {
  return (
    <div className="fixed inset-0 z-[400] bg-cream-100 flex flex-col">
      <div className="flex items-center gap-3 px-5 py-4 border-b border-cream-200 bg-white" style={{ paddingTop: 'max(1rem, env(safe-area-inset-top))' }}>
        <button onClick={onBack} aria-label="Back" className="text-coffee-500"><ArrowLeft size={22} /></button>
        <h2 className="font-display text-xl font-bold text-coffee-800">Operating Agreement</h2>
      </div>
      <div className="flex-1 overflow-y-auto px-5 py-6 space-y-5 pb-20">
        <p className="text-coffee-400 text-xs">Marvelous Business LLC d/b/a Social Brew · Illinois Single-Member LLC</p>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">1. Formation</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">Marvelous Business LLC was formed as an Illinois limited liability company. The Company conducts business under the trade name Social Brew. Its primary business is the operation of Social Brew, a mobile-first platform for discovering and rating independent coffee shops.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">2. Membership</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">Moses Kabuswe is the sole member of the Company and holds 100% of the membership interest. The Company is a single-member LLC treated as a disregarded entity for federal income tax purposes.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">3. Management</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">The Company is member-managed. The Member has full authority to manage all business affairs, enter contracts, open accounts, hire and terminate personnel, and determine business strategy. No meetings or votes are required.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">4. Capital & Distributions</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">The Member contributed the Social Brew application, brand assets, and related intellectual property as initial capital. Distributions may be made at the Member's sole discretion, provided the Company maintains sufficient funds to meet its obligations.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">5. Intellectual Property</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">All intellectual property related to Social Brew — including the name, brand, mug-fill rating mechanic, source code, designs, content, and user data — is the property of the Company.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">6. Limited Liability</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">Except as required by Illinois law, the Member is not personally liable for debts or obligations of the Company. The Member maintains separate Company and personal finances to preserve this protection.</p>
        </section>

        <section className="space-y-2">
          <h3 className="text-coffee-800 font-semibold text-base">7. Governing Law</h3>
          <p className="text-coffee-600 text-sm leading-relaxed">This Agreement is governed by the laws of the State of Illinois (805 ILCS 180/1-1 et seq.).</p>
        </section>

        <p className="text-coffee-400 text-xs text-center pt-2">Marvelous Business LLC d/b/a Social Brew · Illinois</p>
      </div>
    </div>
  )
}
